export function initSlider() {
    var slider_wrapper = $('.daughter_items');

    if (slider_wrapper.length) {
        var slides = slider_wrapper.find('.item');
        var slidesToShow = slider_wrapper.data('slide').slidesToShow;

        slides.slice(slidesToShow).addClass('hidden');
    }

    var cart_slider_wrapper = $('.cart_daughter_items');

    if (cart_slider_wrapper.length) {
        var cart_slides = cart_slider_wrapper.find('.item');
        var cartSlidesToShow = cart_slider_wrapper.data('slide').slidesToShow;

        cart_slides.slice(cartSlidesToShow).addClass('hidden');
    }
}

initSlider();

$(document).on('click', '.related-arrows .next', function () {
    var slider_wrapper = $('.daughter_items');
    var slides = slider_wrapper.find('.item');
    var step = slider_wrapper.data('slide').slidesToScroll;
    var slidesToShow = slider_wrapper.data('slide').slidesToShow;

    var firstActiveIndex = $('.daughter_items .item:not(.hidden):first').index('.daughter_items .item');

    if (
        $('.daughter_items .item')
            .eq(firstActiveIndex + slidesToShow)
            .hasClass('hidden')
    ) {
        slides.slice(firstActiveIndex, firstActiveIndex + step).addClass('hidden');
        slides.slice(firstActiveIndex + slidesToShow, firstActiveIndex + slidesToShow + step).removeClass('hidden');

        if (!$('.daughter_items .item').eq(firstActiveIndex + slidesToShow + step).length) {
            $(this).addClass('disabled');
        }

        if ($('.related-arrows .prev').hasClass('disabled')) {
            $('.related-arrows .prev').removeClass('disabled');
        }
    }
});

$(document).on('click', '.related-arrows .prev', function () {
    var slider_wrapper = $('.daughter_items');
    var slides = slider_wrapper.find('.item');
    var step = slider_wrapper.data('slide').slidesToScroll;
    var slidesToShow = slider_wrapper.data('slide').slidesToShow;

    var firstActiveIndex = $('.daughter_items .item:not(.hidden):first').index('.daughter_items .item');
    var lastActiveIndex = $('.daughter_items .item:not(.hidden):last').index('.daughter_items .item');

    if (lastActiveIndex - slidesToShow >= 0) {
        slides.slice(lastActiveIndex - step + 1, lastActiveIndex + 1).addClass('hidden');
        slides.slice(firstActiveIndex - step, firstActiveIndex).removeClass('hidden');

        if (lastActiveIndex - slidesToShow - step < 0) {
            $(this).addClass('disabled');
        }

        if ($('.related-arrows .next').hasClass('disabled')) {
            $('.related-arrows .next').removeClass('disabled');
        }
    }
});

$(document).on('click', '.cart-related-arrows .next', function () {
    var cart_slider_wrapper = $('.cart_daughter_items');
    var cart_slides = cart_slider_wrapper.find('.item');
    var cart_step = cart_slider_wrapper.data('slide').slidesToScroll;
    var cartSlidesToShow = cart_slider_wrapper.data('slide').slidesToShow;

    var firstActiveIndex = $('.cart_daughter_items .item:not(.hidden):first').index('.cart_daughter_items .item');

    if (
        $('.cart_daughter_items .item')
            .eq(firstActiveIndex + cartSlidesToShow)
            .hasClass('hidden')
    ) {
        cart_slides.slice(firstActiveIndex, firstActiveIndex + cart_step).addClass('hidden');
        cart_slides
            .slice(firstActiveIndex + cartSlidesToShow, firstActiveIndex + cartSlidesToShow + cart_step)
            .removeClass('hidden');

        if (!$('.cart_daughter_items .item').eq(firstActiveIndex + cartSlidesToShow + cart_step).length) {
            $(this).addClass('disabled');
        }

        if ($('.cart-related-arrows .prev').hasClass('disabled')) {
            $('.cart-related-arrows .prev').removeClass('disabled');
        }
    }
});

$(document).on('click', '.cart-related-arrows .prev', function () {
    var cart_slider_wrapper = $('.cart_daughter_items');
    var cart_slides = cart_slider_wrapper.find('.item');
    var cart_step = cart_slider_wrapper.data('slide').slidesToScroll;
    var cartSlidesToShow = cart_slider_wrapper.data('slide').slidesToShow;

    var firstActiveIndex = $('.cart_daughter_items .item:not(.hidden):first').index('.cart_daughter_items .item');
    var lastActiveIndex = $('.cart_daughter_items .item:not(.hidden):last').index('.cart_daughter_items .item');

    if (lastActiveIndex - cartSlidesToShow >= 0) {
        cart_slides.slice(lastActiveIndex - cart_step + 1, lastActiveIndex + 1).addClass('hidden');
        cart_slides.slice(firstActiveIndex - cart_step, firstActiveIndex).removeClass('hidden');

        if (lastActiveIndex - cartSlidesToShow - cart_step < 0) {
            $(this).addClass('disabled');
        }

        if ($('.cart-related-arrows .next').hasClass('disabled')) {
            $('.cart-related-arrows .next').removeClass('disabled');
        }
    }
});
